import { render, staticRenderFns } from "./composite.vue?vue&type=template&id=1a9e2196&"
import script from "./composite.vue?vue&type=script&lang=ts&"
export * from "./composite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9e2196')) {
      api.createRecord('1a9e2196', component.options)
    } else {
      api.reload('1a9e2196', component.options)
    }
    module.hot.accept("./composite.vue?vue&type=template&id=1a9e2196&", function () {
      api.rerender('1a9e2196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/composite.vue"
export default component.exports